import toElr from "./toElr";
import fromElr from "./fromElr";

export default {
  getLatLngFromELR: fromElr.getLatLngFromELR,
  getELRsInRadius: toElr.getELRsInRadius,
};
